import React from 'react';

function LandingTile({ children, className = '', columnClassName = 'col-md-6 mb-3', as: Element = 'article' }) {
  return <div className={columnClassName}><Element className={`landing-info-card h-100 ${className}`.trim()}>{children}</Element></div>;
}

export default LandingTile;
